<template>
  <BlokkliProvider v-bind="blokkliProps">
    <div class="page">
      <DefaultSection class="is-large">
        <Container>
          <ImageItem
            v-if="logo"
            v-bind="logo.image"
            :image-style="imageStyleLogos"
            class="hero-logo"
          />
        </Container>
        <Container>
          <div class="columns">
            <div class="column is-two-thirds-desktop">
              <h1
                class="title is-size-4 is-size-3-tablet is-size-2-desktop has-text-weight-bold mb-5"
              >
                {{ title }}
              </h1>
              <div v-if="text" class="content has-special-bold" v-html="text" />

              <article class="media signature">
                <figure v-if="portrait" class="media-left">
                  <p class="image is-100x100">
                    <ImageItem
                      v-bind="portrait.image"
                      :image-style="portraitPhotos"
                      class="hero-logo"
                    />
                  </p>
                </figure>
                <div class="media-content">
                  <div class="content">
                    <p>
                      <strong>{{ name }}</strong>
                      <br />
                      {{ role }}
                    </p>
                    <ImageItem
                      v-if="signature"
                      v-bind="signature.image"
                      :image-style="signatureStyle"
                      class="signature-image"
                    />
                  </div>
                </div>
              </article>
            </div>
            <div class="column is-offset-1">
              <BlokkliField :list="sidebar" name="field_sidebar" />
            </div>
          </div>
        </Container>
      </DefaultSection>
      <BlokkliField :list="content" name="field_content" />
    </div>
  </BlokkliProvider>
</template>

<script setup lang="ts">
import type { NodeTestimonialFragment } from '#graphql-operations'

const props = defineProps<NodeTestimonialFragment>()

provide<string>('nid', props.id || '')

const portraitPhotos = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    sm: 80,
    md: 80,
    lg: 100,
  },
})

const signatureStyle = defineImageStyle({
  type: 'pictures',
  pictures: {
    xs: {
      width: 250,
    },
  },
})

const imageStyleLogos = defineImageStyle({
  type: 'pictures',
  pictures: {
    xs: {
      width: 300,
    },
    lg: {
      width: 400,
    },
  },
})
</script>

<style lang="scss">
.hero-logo {
  margin-bottom: 2rem;
}

.signature {
  .image {
    &.is-100x100 {
      height: 100px;
      width: 100px;
    }
  }

  margin-top: 5rem;
  img {
    border-radius: 50%;
  }

  .media-content {
    p {
      font-size: 12px;
    }
    .content {
      margin-top: auto;
      align-self: flex-end;
    }
  }
}
</style>
